<template>
<div class="access-code-link">
    <div v-if="action == 'USERUPGRADE'">
        <a href="" style="font-size: .7em;">cancel upgrade</a><br />
    </div>

    <div v-if="aCustomVars['layout'] == 'connectscreen_4.1'">
        <span class="font-E2" id="access-code-verbiage">Or, </span>
        <a class="font-E2  shadowed-text" href="" >connect with an access code</a>
    </div>
    <div v-if="aCustomVars['layout'] == 'radisson_red'">
        <span id="access-code-verbiage">- or - connect with a</span>
        <a class="font-E2  shadowed-text" href="" >VOUCHER</a>
    </div>
    <div v-if="aCustomVars['layout'] != 'connectscreen_4.1' && aCustomVars['layout'] != 'radisson_red'">
        <span id="access-code-verbiage">- or - connect with an</span>
        <a class="font-E2  shadowed-text" href="" >access code</a>
    </div>
</div>
</template>

<script>

export default {
  name: "AccessCodeLink"
}

</script>

<style scoped>

</style>